import * as R from "ramda";
import classnames from "classnames";
import React, { Fragment, useMemo, useState } from "react";
import { Checkbox, Icon, message, Popover, Tag } from "antd";

import { Channel } from "../tab-pages/video-resource-tab";
import { formatSecondsToHumanReadable } from "./asr-line";
import { VisibleSwitch } from "./base-type-carousel-item";
import { sizeToHumanReadableSize } from "./upload-resource-util";
import { addTag, delTag, mediaSourcesDetail } from "../aliyun-service-api";

import "./list-item.scss";

export const detailIsVideo = R.pipe(R.pathOr("", ["type"]), R.equals("video"));

export const PublicOrHiddenTag = (detail) => {
  const { hidden } = detail;
  if (!detailIsVideo(detail)) {
    return null;
  }
  if (hidden) {
    return <Tag color="#f50">已隐藏</Tag>;
  } else {
    return <Tag color="#87d068">已公开</Tag>;
  }
};

//  0: 资源未就绪, 1: 资源就绪
export const StatusTag = ({ status }) => {
  if (status === 0) {
    return <Tag color="volcano">资源未就绪</Tag>;
  } else {
    return (
      <Tag className="hidden" color="#108ee9">
        资源就绪
      </Tag>
    );
  }
};

export const VideoDurationTag = ({ duration }) => {
  if (!duration) {
    return null;
  }
  return (
    <div
      style={{
        padding: "2px 8px",
        borderRadius: 10,
        opacity: 1,
        background: "rgba(0, 0, 0, 0.7)",
        color: "white",
        fontSize: 12,
      }}
    >
      {formatSecondsToHumanReadable(duration)}
    </div>
  );
};

export const addVideoSnapShot = (path) => {
  return `${path}?x-oss-process=video/snapshot,t_3000,f_jpg,w_0,h_200,m_fast,ar_auto`;
};

export const CoverImg = ({ detail, onPreview = R.T }) => {
  const type = R.pathOr("", ["type"], detail);

  const commonStyle  = {
    width: 226,
    maxWidth: 226,
    height: 180,
    maxHeight: 180,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    backgroundPosition: "center",
  }
  switch (type) {
    case "video":
      //  data.items[0].options.coverUrl
      const coverUrl = R.pathOr("", ["options", "coverUrl"], detail);
      // const src =
      //   detail.path +
      //   "?x-oss-process=video/snapshot,t_3000,f_jpg,w_0,h_200,m_fast,ar_auto";
      const src = addVideoSnapShot(detail.path);
      return (
        <div
          onClick={onPreview}
          style={{
            backgroundImage: `url(${coverUrl ? coverUrl : src})`,
            ...commonStyle,
          }}
        ></div>
      );
    case "image":
      return (
        <div
          onClick={onPreview}
          style={{
            backgroundImage: `url(${detail.path})`,
            ...commonStyle,
          }}
        ></div>
      );
    case "audio":
      return (
        <Icon
          theme="twoTone"
          type="sound"
          style={{
            fontSize: 48,
          }}
          onClick={() => {
            onPreview(detail);
          }}
        />
      );

    case "text":
      return (
        <Icon
          theme="twoTone"
          type="file-text"
          style={{
            fontSize: 48,
          }}
          onClick={() => {
            onPreview(detail);
          }}
        />
      );

    default:
      return (
        // <LazyLoad height={180} once>
        <img src={detail.path} alt={detail.title} />
        // </LazyLoad>
      );
  }
};

export const updateOneMediaSourceById = (id, updateFunc = R.T) => {
  return mediaSourcesDetail(id).then((res) => {
    updateFunc(res);
  });
};

export const TagListContent = (props) => {
  const {
    detail,
    availableTags = [],
    updateOne = R.T,
    showLoading = R.T,
    hideLoading = R.T,
    orderId = 0,
    setTagKey = R.T,
  } = props;
  return (
    <div className="flex-wrap">
      {availableTags.map((tag) => {
        const previousIsChecked = R.pathOr([], ["tag_list"], detail).some(
          (t) => t.id === tag.id
        );
        return (
          <Checkbox
            style={{ marginLeft: 0 }}
            key={tag.id}
            checked={previousIsChecked}
            onChange={(e) => {
              const currentIsChecked = e.target.checked;
              if (previousIsChecked === currentIsChecked) {
                return;
              }
              setTagKey(R.inc);
              //  添加
              if (!previousIsChecked && currentIsChecked) {
                //  添加
                showLoading();
                addTag(orderId, detail.id, tag.id).then(
                  () => {
                    message.success("添加成功");
                    updateOneMediaSourceById(detail.id, updateOne).finally(
                      () => {
                        hideLoading();
                      }
                    );
                  },
                  () => {
                    message.error("操作失败");
                  }
                );
              }

              //  删除
              if (previousIsChecked && !currentIsChecked) {
                //  删除
                showLoading();
                delTag(orderId, detail.id, tag.id).then(
                  () => {
                    message.success("删除成功");
                    updateOneMediaSourceById(detail.id, updateOne).finally(
                      () => {
                        hideLoading();
                      }
                    );
                  },
                  () => {
                    message.error("操作失败");
                  }
                );
              }
            }}
          >
            {tag.name}
          </Checkbox>
        );
      })}
    </div>
  );
};

export const TagList = (props) => {
  const { detail } = props;

  const [tagKey, setTagKey] = useState(0);
  return (
    <Fragment>
      {R.pathOr(
        [],
        ["tag_list"]
      )(detail).map((tag, index) => {
        if (index === 0) {
          return (
            <Tag className="ml-2" key={tag.id}>
              {tag.name}
            </Tag>
          );
        }
        if (
          index === R.pipe(R.pathOr([], ["tag_list"]), R.length, R.dec)(detail)
        ) {
          return <span>...</span>;
        }
        return null;
      })}
      <div className="border-dashed">
        <Popover
          key={tagKey}
          title={null}
          content={
            <TagListContent {...props} setTagKey={setTagKey} tagKey={tagKey} />
          }
        >
          <Icon type="plus" className="cursor-pointer" />
        </Popover>
      </div>
    </Fragment>
  );
};

export const useDetailVolumeSize = (detail) => {
  const size = R.pipe(
    R.pathOr("0", ["FileInfoList", 0, "FileBasicInfo", "FileSize"]),
    Number
  )(detail);
  return useMemo(() => {
    if (size) {
      return sizeToHumanReadableSize(size);
    }
    return "--";
  }, [size]);
};

export const useDimension = (detail) => {
  const width = R.pipe(
    R.pathOr("0", ["FileInfoList", 0, "FileBasicInfo", "Width"]),
    Number
  )(detail);
  const height = R.pipe(
    R.pathOr("0", ["FileInfoList", 0, "FileBasicInfo", "Height"]),
    Number
  )(detail);

  return useMemo(() => {
    if (width && height) {
      return `${width}*${height}`;
    }
    return "";
  }, [width, height]);
};

/**
 * img cover 240x135
 * img bottom left: 公开/隐藏
 * img bottom right: 00:28:21
 * 视频名称xxxasdf... [ellipsis]
 * 视频大小: 1.2GB, 640x360
 * 上传者: admin
 * 标签: 标签1, 标签2, 标签3 [+]
 * 视频说明: xxx.... [ellipsis]
 *
 * 2024-03-30 16:22      [tag本地视频/直播切片/合成素材/图片/音频/字幕/视频模板]
 *
 *
 * @param detail Object {
 *         "id": 27,
 *         "aliyun_media_id": "6db402c0651f71ef80a1f7e7c45a6304",
 *         "path": "/80667/1060293/102616/u2atf2rijc.txt",
 *         "desc": "",
 *         "type": "text",
 *         "order_id": 80667,
 *         "hidden": 1,
 *         "name": "culture.txt",
 *         "channel": 1,
 *         "Status": 1,
 *         "category": 1,
 *         "auth_by": 0,
 *         "options": null,
 *         "CreatedAt": "2024-08-28 17:25:13",
 *         "UpdatedAt": "2024-09-03 14:24:28",
 *         "DeletedAt": null,
 *         "admin_detail": {
 *           "id": 0,
 *           "nickname": "",
 *           "oper": "",
 *           "department": 0,
 *           "trash": 0
 *         }
 *       }
 *       @param selectedKeys
 *       @param setSelectedKeys
 *       @param rowKey
 *       @param onPreview
 *       @param availableTags
 *       @param updateOne
 *       @param showLoading
 *       @param hideLoading
 *       @param orderId
 *       @param isDownloaded
 * @returns {Element}
 * @constructor
 */
export const ListItem = ({
  detail,
  selectedKeys,
  setSelectedKeys,
  rowKey,
  onPreview = R.T,
  availableTags = [],
  updateOne = R.T,
  showLoading = R.T,
  hideLoading = R.T,
  orderId,
  isDownloaded = false,
}) => {
  const selected = selectedKeys.includes(detail[rowKey]);

  const sizeStr = useDetailVolumeSize(detail);

  const dimensionStr = useDimension(detail);

  const duration = R.pipe(
    R.pathOr("0", ["FileInfoList", 0, "FileBasicInfo", "Duration"]),
    Number
  )(detail);

  return (
    <div className="resource-list-item position-relative">
      <div className="item-cover-wrap position-relative cursor-pointer">
        <div className="img-wrap flex-x-center flex-y-center">
          <CoverImg onPreview={onPreview} detail={detail} />
        </div>
        <div className="position-absolute left-0 top-0 p-2">
          <StatusTag status={R.pathOr(0, ["Status"], detail)} />
        </div>
        <div className="position-absolute right-0 top-0 p-2">
          <input
            style={{
              transform: "scale(1)",
            }}
            className="cursor-pointer"
            type="checkbox"
            checked={selected}
            onChange={() => {
              if (selected) {
                setSelectedKeys(
                  selectedKeys.filter((key) => key !== detail[rowKey])
                );
              } else {
                setSelectedKeys([...selectedKeys, detail[rowKey]]);
              }
            }}
          />
        </div>
        <div className="position-absolute left-0 bottom-0 p-2 flex">
          <VisibleSwitch detail={detail} updateOne={updateOne} size="small" />
          {isDownloaded && (
            <div className="ml-1">
              <Tag color="#108ee9">已下载</Tag>
            </div>
          )}
        </div>
        <div className="position-absolute bottom-0 right-0 p-2">
          <VideoDurationTag duration={duration} />
        </div>
      </div>
      <div className="item-info pt-2 children-space-y-1">
        <div className="item-title ellipsis">
          名称:{" "}
          <span title={R.pathOr("--", ["name"], detail)}>
            {R.pathOr("--", ["name"], detail)}
          </span>
        </div>
        <div className="item-size">
          大小:{sizeStr} {dimensionStr}
        </div>
        <div className="item-uploader">
          创建时间:{R.pathOr("", ["CreatedAt"], detail)}
        </div>
        <div className="item-tags flex-y-center">
          <span>标签:</span>
          <TagList
            detail={detail}
            availableTags={availableTags}
            updateOne={updateOne}
            orderId={orderId}
            showLoading={showLoading}
            hideLoading={hideLoading}
          />
        </div>

        <div
          className={classnames("item-desc ellipsis", {
            hidden: !detailIsVideo(detail),
          })}
          title={R.pathOr("", ["desc"], detail)}
        >
          {(() => {
            const type = R.pathOr("", ["type"])(detail);
            switch (type) {
              case "video":
                return `视频`;
              case "audio":
                return `音频`;
              case "image":
                return `图片`;
              case "text":
                return `文本`;
              default:
                return "";
            }
          })()}
          说明:
          {R.ifElse(
            R.isEmpty,
            R.always("--"),
            R.identity
          )(R.pathOr("", ["desc"], detail))}
        </div>
      </div>

      <div className="position-absolute w-full flex-y-center bottom-0 left-0 p-2">
        <div className="item-time ellipsis" title={R.pathOr("", ["admin_detail", "nickname"], detail)}>
          {R.pathOr("", ["admin_detail", "nickname"], detail)}
        </div>
        <div className="ml-auto flex-y-center">
          <Channel detail={detail} value={detail.channel} />
        </div>
      </div>
    </div>
  );
};

export const ListItemDiv = ({ children }) => {
  return <div className="resource-list-item">{children}</div>;
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/list-item.js